import fbPost from './mixins/postToFeed.js';
export default {
  mixins: [fbPost],
  props: ['user_id', 'old_answers', 'test', 'quizroom'],
  data() {
    return {
      loadedInfo: true,
      kitxvebi: [{}],
      score: 0,
      current: 0,
      showCurrent: 0,
      answer: '',
      answers_array: [],
      progress: true,
      historyBtn: false,
      checking: false,
      nextHist: 'ისტორია',
      total: 0,
      resultId: false,
      storeError: false,
      sending: false,
      sendingDone: false,
      sendingDisable: false,
      storageKey: this.test.id,
      timeline: {},
      // starting form fresh page continiue form profile
      // fresh:true,

      finished: false,
      downBtns: true,
    };
  },
  methods: {
    latestQuestion() {
      if (this.checking) this.next();
      this.showCurrent = this.answers_array.length;
      this.current = this.answers_array.length;
    },
    check() {
      this.historyBtn = true;
      if (this.kitxvebi[this.showCurrent].type_id != 2) {
        if (this.answer.correct == 1) this.score++;
        if (this.total >= this.current - 1)
          this.answers_array.push(this.answer);
      } else {
        console.log(this.timeline);
        this.answers_array.push(this.timeline);
        for (
          var i = 0;
          i < this.kitxvebi[this.showCurrent].options.length;
          i++
        ) {
          console.log(this.kitxvebi[this.showCurrent].options[i]);
          console.log(this.timeline[i]);
          if (
            this.kitxvebi[this.showCurrent].options[i].timeline ==
            this.timeline[i]
          ) {
            console.log('correct');
          } else {
            console.log('wrong');
          }
        }
        this.timeline = {};
      }
      this.checking = true;
    },
    next() {
      if (!this.checking) {
        this.showCurrent = this.answers_array.length;
        return;
      }
      this.checking = false;
      // console.log(this.$refs.scoreBoard);
      // window.scroll(0, this.$refs.scoreBoard.offsetTop)
      if (this.total > this.current) {
        this.current++;
        this.showCurrent = this.current;
        if (this.current % 3 === 0) {
          this.storeProgress();
        }
        if (this.current % 1 === 0) {
          this.storeInStorage();
        }
      } else {
        // when finished
        this.finished = true;
        this.historyBtn = false;
        this.progress = false;
        if (!this.quizroom) localStorage.removeItem(this.storageKey);
        this.storeProgress(true);
      }
      if (this.quizroom) {
        window.bus.$emit('nextQuestion', {
          score: this.score,
          current: this.phpCurrent,
          finished: this.finished,
        });
      }
    },
    toggleQuiz() {
      this.progress = !this.progress;
      this.nextHist = this.nextHist == 'ისტორია' ? 'გაგრძელება' : 'ისტორია';
    },

    storeProgress($choice = false) {
      if (!this.user_id && $choice) {
        this.$emit('changeunauth');
        showRegister(true);
      }
      this.sendingDisable = true;
      this.sending = true;
      this.storeError = false;
      let url =
        this.finished && this.user_id ? '/result/finished' : '/result/progress';
      axios
        .post(url, {
          id: this.resultId,
          user_id: this.user_id,
          test_id: this.test.id,
          answers: this.answers_array,
          current: this.phpCurrent,
          score: this.score,
          total: this.total,
          finished: this.finished,
        })
        .then((res) => {
          if (res.data.id) this.resultId = res.data.id;
          this.sending = false;
          this.sendingDone = true;
          setTimeout(() => {
            this.sendingDone = false;
            this.sendingDisable = false;
          }, 1500);
        })
        .catch((errors) => {
          this.sendingDisable = false;
          this.storeError = true;
          this.sending = false;
          console.log(errors);
        });
    },

    startAgain() {
      if (confirm('ნამდვილად გსურთ ტესტის თავიდან დაწყება?')) {
        this.current = 0;
        this.showCurrent = 0;
        this.answers_array = [];
        this.answer = '';
        this.historyBtn = false;
        this.checking = false;
        localStorage.removeItem(this.storageKey);
      }
    },
    // store user answers in storage
    storeInStorage() {
      let data = {
        testId: this.test.id,
        answers: this.answers_array,
        current: this.current,
        score: this.score,
      };
      localStorage.setItem(this.storageKey, JSON.stringify(data));
    },
    getAnswersFromStorage() {
      let data = localStorage.getItem(this.storageKey);
      if (data) {
        console.log('getAnswersFromStorage');
        data = JSON.parse(data);
        this.answers_array = data.answers;
        this.current = data.current;
        this.score = data.score;
        this.showCurrent = data.current;
        this.historyBtn = true;
      }
    },
    setStorageKey() {
      if (this.quizroom) {
        this.storageKey = this.quizroom.code;
      } else if (this.old_answers) this.storageKey = 'continiue' + this.test.id;
    },

    getTest() {
      axios
        .get('/api/test/' + this.test.id)
        .then((data) => {
          this.kitxvebi = data.data.questions;
          this.loadedInfo = false;
          this.total = this.kitxvebi.length - 1;
        })
        .catch((errors) => console.log(errors));
    },

    setQuizData() {
      this.getAnswersFromStorage();
      if (this.old_answers) {
        this.resultId = this.old_answers.id;
        if (
          this.old_answers.current > this.current ||
          this.old_answers.answers.length == 1
        ) {
          this.current = this.old_answers.current;
          this.showCurrent = this.old_answers.current;
          this.answers_array = this.old_answers.answers;
          this.score = this.old_answers.score;
        }
        if (this.old_answers.finished) {
          this.finished = true;
          this.checking = false;
          this.historyBtn = false;
          this.progress = false;
        } else this.historyBtn = true;
      }
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        evt.target.value = '';
        return true;
      }
    },
  },
  mounted() {
    this.getTest();
    this.setStorageKey();
    this.setQuizData();
  },
  computed: {
    phpCurrent: function () {
      return this.checking ? this.current + 1 : this.current;
    },
    question_id: function () {
      return this.kitxvebi[this.showCurrent].id;
    },
  },
};
